import Calendar from "@toast-ui/react-calendar";
import React from "react";
import Layout_Dashboard from "../Layout_Dashboard/Layout_Dashboard";
import Moment from "moment";
import "tui-calendar/dist/tui-calendar.css";
import "tui-date-picker/dist/tui-date-picker.css";
import "tui-time-picker/dist/tui-time-picker.css";
import { Button, Menu, MenuItem } from "@material-ui/core";
import classes from "./Scheduler.module.css";
import {
  ArrowBackIosOutlined,
  ArrowForwardIosOutlined,
} from "@material-ui/icons";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import MomentUtils from "@date-io/moment";
import { SCHEDULER } from "../../utils/url-builder";
import BaseService from "../../store/services/base.service";
import { BASE_URL } from "../../config";
import { getKneuraId, getUserId } from "../../utils/authentication-access";
import CreationPopup from "./CreationPopup";
import { debounce, reject } from "lodash";
import JoinClassPopup from "./JoinClassPopup";
import StartLivePopup from "./StartLivePopup";
import { extendMoment } from "moment-range";
const moment = extendMoment(Moment);

class Scheduler extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      today: null,
      displayDate: null,
      schedules: [],
      classes: [],
      viewAnchorEl: null,
      viewType: "Month View",
      showCreationPopup: false,
      creationPopup: {
        startDate: moment().toDate(),
        endDate: moment().toDate(),
      },
      editPopup: false,
      editDoc: null,
      showJoinClassPopup: false,
      showLiveClassPopup: false,
    };
    this.calendar = React.createRef();
  }

  componentDidMount() {
    this.setState({
      today: new Date().toDateString(),
      displayDate: new Date().toDateString(),
    });
    this.getSchedules();
    this.getClasses();
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (
      nextState.schedules.length != this.state.schedules.length ||
      nextState.classes.length != this.state.classes.length
    )
      return true;
    return false;
  }

  getClasses = () => {
    let classes = JSON.parse(localStorage.getItem("classes"));
    classes = classes.map((item) => {
      return {
        id: item.kneuraId,
        name: item.name,
        bgColor: "#9e5fff",
        borderColor: "#9e5fff",
      };
    });
    this.setState({ classes });
  };

  getSchedules = async () => {
    try {
      let class_ids = JSON.parse(localStorage.getItem("classes"));
      class_ids = class_ids.map((item) => item.kneuraId);
      class_ids = JSON.stringify(class_ids);
      const url = SCHEDULER.fetch();
      const res = await new BaseService().makeGetRequestGeneric(url, {
        class_ids,
      });
      const newSchedules = res.schedules.reduce((prevValue, schedule) => {
        if (schedule.ocurrence === "DAILY") {
          const range = moment.rangeFromInterval(
            "days",
            365,
            schedule.startDate,
          );
          const dates = Array.from(range.by("day"));
          const recurringSchedules = dates.map((date, index) => {
            return {
              id: schedule.id + "$$$" + index,
              calendarId: schedule.classId,
              title: schedule.title,
              location: schedule.description,
              body: schedule.description,
              category: "time",
              customCategory: schedule.category,
              start: date
                .set("hours", moment(schedule.startDate).get("hours"))
                .toISOString(),
              end: date
                .set("hours", moment(schedule.endDate).get("hours"))
                .toISOString(),
              isVisible: true,
              url: schedule.url,
              ocurrence: schedule.ocurrence,
            };
          });
          console.log(recurringSchedules);
          return prevValue.concat(recurringSchedules);
        } else if (schedule.ocurrence === "WEEKLY") {
          const range = moment.rangeFromInterval(
            "days",
            365,
            schedule.startDate,
          );
          const dates = Array.from(range.by("weeks"));
          const recurringSchedules = dates.map((date, index) => {
            return {
              id: schedule.id + "$$$" + index,
              calendarId: schedule.classId,
              title: schedule.title,
              location: schedule.description,
              body: schedule.description,
              category: "time",
              customCategory: schedule.category,
              start: date
                .set("hours", moment(schedule.startDate).get("hours"))
                .toISOString(),
              end: date
                .set("hours", moment(schedule.endDate).get("hours"))
                .toISOString(),
              isVisible: true,
              url: schedule.url,
              ocurrence: schedule.ocurrence,
            };
          });
          console.log(recurringSchedules);
          return prevValue.concat(recurringSchedules);
        } else if (schedule.ocurrence === "MONTHLY") {
          const range = moment.rangeFromInterval(
            "days",
            365,
            schedule.startDate,
          );
          const dates = Array.from(range.by("months"));
          const recurringSchedules = dates.map((date, index) => {
            return {
              id: schedule.id + "$$$" + index,
              calendarId: schedule.classId,
              title: schedule.title,
              location: schedule.description,
              body: schedule.description,
              category: "time",
              customCategory: schedule.category,
              start: date
                .set("hours", moment(schedule.startDate).get("hours"))
                .toISOString(),
              end: date
                .set("hours", moment(schedule.endDate).get("hours"))
                .toISOString(),
              isVisible: true,
              url: schedule.url,
              ocurrence: schedule.ocurrence,
            };
          });
          console.log(recurringSchedules);
          return prevValue.concat(recurringSchedules);
        } else if (schedule.ocurrence === "YEARLY") {
          const range = moment.rangeFromInterval(
            "days",
            365,
            schedule.startDate,
          );
          const dates = Array.from(range.by("years"));
          const recurringSchedules = dates.map((date, index) => {
            return {
              id: schedule.id + "$$$" + index,
              calendarId: schedule.classId,
              title: schedule.title,
              location: schedule.description,
              body: schedule.description,
              category: "time",
              customCategory: schedule.category,
              start: date
                .set("hours", moment(schedule.startDate).get("hours"))
                .toISOString(),
              end: date
                .set("hours", moment(schedule.endDate).get("hours"))
                .toISOString(),
              isVisible: true,
              url: schedule.url,
              ocurrence: schedule.ocurrence,
            };
          });
          console.log(recurringSchedules);
          return prevValue.concat(recurringSchedules);
        } else if (schedule.ocurrence === "WEEKDAY") {
          const range = moment.rangeFromInterval(
            "days",
            365,
            schedule.startDate,
          );
          const dates = Array.from(range.by("days"));
          const recurringSchedules = dates
            .filter((date) => {
              console.log(date.day());
              return date.day() !== 0 && date.day() !== 6;
            })
            .map((date, index) => {
              return {
                id: schedule.id + "$$$" + index,
                calendarId: schedule.classId,
                title: schedule.title,
                location: schedule.description,
                body: schedule.description,
                category: "time",
                customCategory: schedule.category,
                start: date
                  .set("hours", moment(schedule.startDate).get("hours"))
                  .toISOString(),
                end: date
                  .set("hours", moment(schedule.endDate).get("hours"))
                  .toISOString(),
                isVisible: true,
                url: schedule.url,
                ocurrence: schedule.ocurrence,
              };
            });
          console.log(recurringSchedules);
          return prevValue.concat(recurringSchedules);
        } else
          return prevValue.concat([
            {
              id: schedule.id,
              calendarId: schedule.classId,
              title: schedule.title,
              location: schedule.description,
              body: schedule.description,
              category: "time",
              customCategory: schedule.category,
              start: moment(schedule.startDate).toISOString(),
              end: moment(schedule.endDate).toISOString(),
              isVisible: true,
              url: schedule.url,
              ocurrence: schedule.ocurrence,
            },
          ]);
      }, []);
      this.setState({ schedules: newSchedules }, this.forceUpdate);
    } catch (error) {
      console.log({ error });
    }
  };

  createSchedule = async (schedule) => {
    if (!schedule.useCreationPopup && !schedule.title) {
      this.setState(
        {
          showCreationPopup: true,
          creationPopup: {
            startDate: schedule.start.toDate(),
            endDate: schedule.end.toDate(),
          },
        },
        this.forceUpdate,
      );
      schedule.guide.clearGuideElement();
      return;
    }
    try {
      const url = SCHEDULER.create();
      const data = {
        classId: schedule.calendarId,
        title: schedule.title,
        description: schedule.location,
        url: schedule.url,
        startDate: new Date(schedule.start),
        endDate: new Date(schedule.end),
        category: schedule.category,
        ocurrence: schedule.ocurrence,
        creatorId: getKneuraId(),
      };
      const res = await new BaseService().makePostRequestGeneric(url, data);
      this.setState({ showCreationPopup: false });
      await this.getSchedules();
    } catch (error) {
      console.log({ error });
    }
  };

  updateSchedule = async (data) => {
    if (!data.changes) {
      const existingSchedule = this.state.schedules.find(
        (schedule) => schedule.id == data.schedule.id,
      );
      console.log(existingSchedule);
      this.setState(
        {
          showCreationPopup: true,
          editPopup: true,
          editDoc: existingSchedule,
        },
        this.forceUpdate,
      );
      return;
    }
    try {
      const url = SCHEDULER.update();
      const formData = {
        id: data.schedule.id,
        classId: data.changes.calendarId || data.schedule.calendarId,
        title: data.changes.title || data.schedule.title,
        description: data.changes.location || data.schedule.location,
        startDate: data.changes.start
          ? new Date(data.changes.start)
          : new Date(data.schedule.start),
        endDate: data.changes.end
          ? new Date(data.changes.end)
          : new Date(data.schedule.end),
      };
      await new BaseService().makePostRequestGeneric(url, formData);
      await this.getSchedules();
    } catch (error) {
      console.log({ error });
    }
  };

  forceUpdateSchedule = async (data) => {
    try {
      const url = SCHEDULER.update();
      const formData = {
        id: data.id,
        classId: data.classId,
        title: data.title,
        description: data.location,
        startDate: data.start,
        endDate: data.end,
        url: data.url,
        category: data.category,
        ocurrence: data.ocurrence,
      };
      await new BaseService().makePostRequestGeneric(url, formData);
      await this.getSchedules();
      this.setState({ showCreationPopup: false }, this.forceUpdate);
    } catch (error) {
      console.log({ error });
    }
  };

  deleteSchedule = async (data) => {
    try {
      const url = SCHEDULER.delete(data.schedule.id);
      await new BaseService().makePostRequestGeneric(url, {});
      await this.getSchedules();
    } catch (error) {
      console.log({ error });
    }
  };

  render() {
    const { displayDate } = this.state;
    const self = this;
    const myTheme = {},
      today = this.state.today;
    return (
      <Layout_Dashboard
        classname={this.props.classname}
        breadCrumb={["Calendar"]}
        openClassesDrawer={() => {
          this.props.openClassesDrawer();
        }}
      >
        {/* <h1>Scheduler</h1> */}

        <div
          id="calendar"
          style={{ height: "100%", width: "100%", background: "white" }}
        >
          <div
            style={{
              height: "6%",
              // width: "100%",
              display: "grid",
              gridTemplateColumns: "13% 74% 13%",
              padding: "1%",
              alignContent: "center",
            }}
          >
            <Button
              variant="outlined"
              className={classes.DefaultBtn}
              // startIcon={<PlusIcon />}
              onClick={(event) => {
                // this.calendar.current.calendarInst._openCreationPopup();
                this.setState(
                  {
                    showCreationPopup: true,
                  },
                  this.forceUpdate,
                );
              }}
              style={{ visibility: "hidden" }}
            >
              +<span style={{ paddingLeft: "0.5vw" }}>Create Event</span>
            </Button>
            <div style={{ textAlign: "center", alignSelf: "center" }}>
              <ArrowBackIosOutlined
                style={{ fontSize: "1.1rem" }}
                onClick={(e) => {
                  if (this.state.viewType == "Month View") {
                    this.setState(
                      {
                        displayDate: moment(displayDate).subtract(1, "month"),
                      },
                      this.forceUpdate,
                    );
                  } else if (this.state.viewType == "Week View") {
                    this.setState(
                      {
                        displayDate: moment(displayDate).subtract(1, "week"),
                      },
                      this.forceUpdate,
                    );
                  } else if (this.state.viewType == "Day View") {
                    this.setState(
                      {
                        displayDate: moment(displayDate).subtract(1, "day"),
                      },
                      this.forceUpdate,
                    );
                  }
                  this.calendar.current.calendarInst.prev();
                }}
              />
              <span style={{ padding: "1%", fontSize: "22px" }}>
                {this.state.viewType == "Month View"
                  ? moment(displayDate).format("MMMM YYYY")
                  : this.state.viewType == "Week View"
                  ? moment(displayDate).format("MMMM") +
                    " " +
                    moment(displayDate).startOf("week").format("DD") +
                    "-" +
                    moment(displayDate).endOf("week").format("DD") +
                    " " +
                    moment(displayDate).format("YYYY")
                  : moment(displayDate).format("MMMM DD, YYYY")}
              </span>
              <ArrowForwardIosOutlined
                style={{ fontSize: "1.1rem" }}
                onClick={(e) => {
                  if (this.state.viewType == "Month View") {
                    this.setState(
                      {
                        displayDate: moment(displayDate).add(1, "month"),
                      },
                      this.forceUpdate,
                    );
                  } else if (this.state.viewType == "Week View") {
                    this.setState(
                      {
                        displayDate: moment(displayDate).add(1, "week"),
                      },
                      this.forceUpdate,
                    );
                  } else if (this.state.viewType == "Day View") {
                    this.setState(
                      {
                        displayDate: moment(displayDate).add(1, "day"),
                      },
                      this.forceUpdate,
                    );
                  }
                  this.calendar.current.calendarInst.next();
                }}
              />
              <Button
                variant="outlined"
                style={{ marginLeft: "2%", borderRadius: "25px" }}
                onClick={(e) => {
                  this.setState({ displayDate: moment() }, this.forceUpdate);
                  this.calendar.current.calendarInst.today();
                }}
              >
                Today
              </Button>
            </div>
            <Button
              style={{
                boxShadow: "none",
                marginTop: "1vh",
              }}
              variant="outlined"
              endIcon={<ArrowDropDownIcon />}
              onClick={(e) =>
                this.setState({ viewAnchorEl: e.target }, this.forceUpdate)
              }
            >
              {this.state.viewType}
            </Button>
          </div>
          <Calendar
            ref={this.calendar}
            usageStatistics={false}
            height="90%"
            calendars={this.state.classes}
            disableDblClick={true}
            disableClick={false}
            isReadOnly={true}
            month={{
              startDayOfWeek: 0,
              moreLayerSize: { width: "20%", height: "100%" },
            }}
            schedules={this.state.schedules}
            // scheduleView={true}
            taskView={true}
            template={{
              milestone(schedule) {
                return `<span style="color:#fff;background-color: ${
                  "white" || schedule.bgColor
                };">${schedule.title}</span>`;
              },
              milestoneTitle() {
                return "Milestone";
              },
              allday(schedule) {
                return `${schedule.title}<i className="fa fa-refresh"></i>`;
              },
              alldayTitle() {
                return "All Day";
              },
              locationPlaceholder() {
                return "Description";
              },
              titlePlaceholder() {
                return "Subject";
              },
              popupDetailLocation(schedule) {
                const existingSchedule = self.state.schedules.find(
                  (s) => schedule.id === s.id,
                );
                console.log(existingSchedule);
                if (existingSchedule.url)
                  return `${existingSchedule.location}&nbsp;(<a style="color: blue;" href="${existingSchedule.url}" target="_blank">Link</a>)`;
                return `${existingSchedule.location}`;
              },
            }}
            onClickSchedule={(e) => {
              setTimeout(() => {
                const popup = document.getElementsByClassName(
                  "tui-full-calendar-popup-detail-item-separate",
                );
                const existingSchedule = this.state.schedules.find(
                  (schedule) => schedule.id == e.schedule.id,
                );
                window.joinEvent = () => {
                  this.setState(
                    {
                      showJoinClassPopup: true,
                      editDoc: existingSchedule,
                    },
                    this.forceUpdate,
                  );
                };
                window.goLive = () => {
                  this.setState(
                    {
                      showLiveClassPopup: true,
                    },
                    this.forceUpdate,
                  );
                };
                const JoinButton =
                  "<button class='btn-button-learn' onclick='joinEvent()'>Join</button>";
                const LiveButton =
                  "<button class='btn-button-learn' onclick='goLive()'>Go Live</button>";
                popup[0].innerHTML = JoinButton;
              }, 500);
            }}
            onBeforeCreateSchedule={this.createSchedule}
            onBeforeUpdateSchedule={this.updateSchedule}
            onBeforeDeleteSchedule={this.deleteSchedule}
            theme={myTheme}
            timezones={[
              {
                timezoneOffset: 330,
                displayLabel: "GMT+5:30",
                tooltip: "India",
              },
            ]}
            useDetailPopup
            useCreationPopup={false}
            view={"month"}
            week={{
              showTimezoneCollapseButton: true,
              timezonesCollapsed: true,
            }}
          />
        </div>
        <CreationPopup
          showCreationPopup={this.state.showCreationPopup}
          closeCreationPopup={() => {
            this.setState({ showCreationPopup: false }, this.forceUpdate);
          }}
          startDate={this.state.creationPopup.startDate}
          endDate={this.state.creationPopup.endDate}
          createSchedule={this.createSchedule}
          classes={this.state.classes}
          editPopup={this.state.editPopup}
          editDoc={this.state.editDoc}
          updateSchedule={this.forceUpdateSchedule}
        />
        <JoinClassPopup
          showJoinClassPopup={this.state.showJoinClassPopup}
          closeJoinClassPopup={() => {
            this.setState({ showJoinClassPopup: false }, this.forceUpdate);
          }}
        />
        <StartLivePopup
          showLiveClassPopup={this.state.showLiveClassPopup}
          closeLiveClassPopup={() => {
            this.setState({ showLiveClassPopup: false }, this.forceUpdate);
          }}
        />
        <Menu
          id="sorter-menu"
          anchorEl={this.state.viewAnchorEl}
          keepMounted
          open={Boolean(this.state.viewAnchorEl)}
          onClose={(e) =>
            this.setState({ viewAnchorEl: null }, this.forceUpdate)
          }
        >
          <MenuItem
            onClick={() => {
              this.setState(
                {
                  viewType: "Month View",
                  viewAnchorEl: null,
                  today: moment(),
                  displayDate: moment(),
                },
                this.forceUpdate,
              );
              this.calendar.current.calendarInst.changeView("month", true);
              this.calendar.current.calendarInst.today();
            }}
          >
            Month View
          </MenuItem>
          <MenuItem
            onClick={(e) => {
              this.setState(
                {
                  viewType: "Week View",
                  viewAnchorEl: null,
                  today: moment(),
                  displayDate: moment(),
                },
                this.forceUpdate,
              );
              this.calendar.current.calendarInst.changeView("week", true);
              this.calendar.current.calendarInst.today();
            }}
          >
            Week View
          </MenuItem>
          <MenuItem
            onClick={(e) => {
              this.setState(
                {
                  viewType: "Day View",
                  viewAnchorEl: null,
                  today: moment(),
                  displayDate: moment(),
                },
                this.forceUpdate,
              );
              this.calendar.current.calendarInst.changeView("day", true);
              this.calendar.current.calendarInst.today();
            }}
          >
            Day View
          </MenuItem>
        </Menu>
      </Layout_Dashboard>
    );
  }
}

export default Scheduler;
